import { withRouter, Link } from 'react-router'
import { pluralize } from 'humanize-plus'
import CalendarSettingsPage from './page'
import MeetingTypeList from './MeetingTypesList'
import { SectionItem } from 'components/shared/Section'

import { UpgradeModal } from '@driftt/billing-components'

import GlobalCalendarInfo from './GlobalCalendarInfo'
import CalendarTabHeader from 'components/settings/meetings/CalendarTabHeader'

const CalendarSettings = ({
  isGoogleAuthed,
  isMicrosoftAuthed,
  calendar,
  isCreatingNew,
  handleCreateMeetingType,
  router,
  isTokenRevoked,
  hasBetaGlobalCalendars,
  isGlobalCalendarManaged,
  isUpgradeModalOpen,
  setUpgradeModal,
  isOnFreePlan,
  hasMeetings,
  meetingTypes,
}) => {
  const isGloballyManagedAndInBeta = hasBetaGlobalCalendars && isGlobalCalendarManaged
  const connected = (isGoogleAuthed || isMicrosoftAuthed || isGloballyManagedAndInBeta) && !!calendar.id
  const totalMeetingTypesLength = (meetingTypes && meetingTypes.length) + 1 // add one for default meeting type
  return (
    <CalendarSettingsPage
      isTokenRevoked={isTokenRevoked}
      showHeaderBorder={!connected}
      hasBetaGlobalCalendars={hasBetaGlobalCalendars}
      isGlobalCalendarManaged={isGlobalCalendarManaged}
    >
      <CalendarTabHeader router={router} view="MEETINGS" />
      {!connected && isGloballyManagedAndInBeta && <GlobalCalendarInfo />}
      <div className="subsection top">
        <div className="flex-space-between">
          <div className="subheader">{totalMeetingTypesLength} Meeting {pluralize(totalMeetingTypesLength, 'Type')}</div>
          <button
            className="tide-button tide-button--secondary"
            disabled={isCreatingNew}
            onClick={() =>
              !isOnFreePlan || hasMeetings ? handleCreateMeetingType() : setUpgradeModal(true)
            }
          >
            {isCreatingNew ? 'Creating...' : '+ New Meeting Type'}
          </button>
        </div>
        <MeetingTypeList gatedOnClick={() => setUpgradeModal(true)} />
        {isUpgradeModalOpen && (
          <UpgradeModal
            onCloseInitiated={() => setUpgradeModal(false)}
            headLineFeatureText={'Custom Drift Meeting Types'}
            planName={'Standard'}
            isMonthlyBilling={true}
          />
        )}
      </div>

      {connected && (
        <SectionItem
          title="Your Drift Assistant is connected to your calendar"
          description="The Drift Assistant helps you close more deals by preparing you for your meetings and sending you reminders for important deals so you never accidentally lose an opportunity again."
          className="assistant-config-footer-section"
        >
          <Link to="/settings/assistant">Manage your Drift Assistant</Link>
        </SectionItem>
      )}
    </CalendarSettingsPage>
  )
}

export default withRouter(CalendarSettings)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/meetings/component.js